const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

const STORAGE_KEY = "b2bUtmParams";

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

const readFromSearch = (search: string): UtmParams => {
  const params = new URLSearchParams(search);

  return UTM_KEYS.reduce<UtmParams>((acc, key) => {
    const value = params.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {});
};

export const getStoredUtmParams = (): UtmParams => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? (JSON.parse(stored) as UtmParams) : {};
  } catch {
    return {};
  }
};

export const captureUtmParams = () => {
  const landed = readFromSearch(window.location.search);

  if (!Object.keys(landed).length) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(landed));
  } catch {}
};

export const getUtmParams = (): UtmParams => ({
  ...getStoredUtmParams(),
  ...readFromSearch(window.location.search),
});
